import { useState, useEffect } from "react";
import axios from "axios";

const useLeaguesList = (currentSport, searchInput) => {
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLeagues = async () => {
      setLoading(true);
      try {
        const url =
          window.location.hostname === "localhost"
            ? "https://tool.bonusbank.com.au/api/v3/leagues"
            : `${window.location.origin}/wp-json/bonusbank/v1/leagues`;
        var params = {};
        if (!!searchInput) {
          params = { search: searchInput, ...params };
        }
        if (!!currentSport) {
          params = { sport: currentSport, ...params };
        }
        const response = await axios.get(url, {
          params,
          headers: {
            "content-type": "application/json",
            "X-WP-Nonce": window.nonce,
          },
        });
        setLeagues(response.data.leagues);
        setError(null);
      } catch (err) {
        setError(err);
        setLeagues([]);
      } finally {
        setLoading(false);
      }
    };
    fetchLeagues();
  }, [currentSport, searchInput]);

  return { leagues, loading, error };
};

export default useLeaguesList;
